var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d2881e074d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2881e074d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#da7c0f",
    d: "M 15 0 C 6.984375 0 0.484375 6.5 0.484375 14.515625 C 0.484375 22.535156 6.984375 29.03125 15 29.03125 C 23.015625 29.03125 29.515625 22.535156 29.515625 14.515625 C 29.515625 6.5 23.015625 0 15 0 Z M 15 26.128906 C 8.597656 26.128906 3.386719 20.917969 3.386719 14.515625 C 3.386719 8.113281 8.597656 2.902344 15 2.902344 C 21.402344 2.902344 26.613281 8.113281 26.613281 14.515625 C 26.613281 20.917969 21.402344 26.128906 15 26.128906 Z M 15 26.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da7c0f",
    d: "M 7.742188 13.066406 L 22.257812 13.066406 L 22.257812 15.96875 L 7.742188 15.96875 Z M 7.742188 13.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.e7b285cb86cf5a52b88b362a3eed64f7.svg";
export { ForwardRef as ReactComponent };